export const ACADEMY_MENU_ROUTES = {
  home: '/',
  quickStart: '/quick-start',
  documentation: '/documentation',
  glossary: '/glossary',
  videos: '/videos',
  codeSandbox: '/code-sandbox',
} as const

export const ACADEMY_CODE_SANDBOX_PATH = ACADEMY_MENU_ROUTES.codeSandbox

/**
 * Toggle Code Sandbox entry in academy navigation and /code-sandbox routes.
 * Set to true when the feature is ready to ship.
 */
export const IS_CODE_SANDBOX_ENABLED = false
